import { http } from 'lib/client/http';
import { sha256 } from 'js-sha256';
import { ISignUpRequestData } from '../model/SignUp.model';

export function signUp(data: ISignUpRequestData) {
    return http.post('/signup', {
        username: data.email,
        password: sha256(data.password),
        grant_type: 'password',
        scope: 'profile',
        client_id: process.env.REACT_APP_CLIENT_ID,
        redirect_uri: process.env.REACT_APP_REDIRECT_URI,
    }, {});
}
